import { render, staticRenderFns } from "./OrdenacaoPastoral.vue?vue&type=template&id=227d0676&scoped=true"
import script from "./OrdenacaoPastoral.vue?vue&type=script&lang=js"
export * from "./OrdenacaoPastoral.vue?vue&type=script&lang=js"
import style0 from "./OrdenacaoPastoral.vue?vue&type=style&index=0&id=227d0676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d0676",
  null
  
)

export default component.exports